<template>
  <div class="tail">
    <div class="tai">
      <div>平台链接</div>
      <div class="platform">
        <a href="http://www.cnipa.gov.cn/" target="_blank">国家知识产权局</a>
        <a href="https://www.wipo.int/portal/zh/" target="_blank">世界知识产权组织</a>
        <a href="http://www.cas.cn/" target="_blank">中国科学院</a>
        <a href="http://www.ipph.cn/" target="_blank">知识产权出版社</a>
        <a href="http://www.caict.ac.cn/" target="_blank">中国信通院</a>
        <a href="http://www.shexgrp.com/" target="_blank">上海交易集团</a>
        <a href="http://www.suaee.com" target="_blank">上海联合产权交易所</a>
        <a href="https://www3.wipo.int/wipogreen/en/" target="_blank">WIPO Green</a>
        <a href="http://www.shaaee.com/" target="_blank">上海农村产权交易所</a>
        <a href="http://www.ssgate.org/" target="_blank">南南全球技术产权交易所</a>
        
      </div>

      <div class="contact">
        <div class="couplet">
          <div class="sixteen" style="font-size: 18px">关于我们</div>
          <!-- <div class="sixteen">联系我们</div> -->
          <router-link to="/information">
            <div class="sixteen">信息公开</div>
          </router-link>
          <router-link to="/information?in1=2&in2=2">
            <div class="sixteen">加入我们</div>
          </router-link>
        </div>
        <div class="feedback">
          <div class="sixteen" style="font-size: 18px">帮助中心FAQ</div>
          <div class="sixteen">
            <a href="mailto:info@shsipe.com" target="_blank">意见反馈</a>
          </div>

          <div class="sixteen">
            <a :href="downloadUrl" target="_blank"> 新手教程 </a>
          </div>
        </div>
        <div class="Telephone">
          <div class="sixteen">如有任何问题，请随时联系我们</div>
          <div style="width: 302px; color: #86909c; line-height: 1.5">
            <div>联系电话：021-50633728</div>
            <div>
              地址：上海市浦东新区环科路999弄15号楼
            </div>
            <div>邮编：201210</div>
          </div>
        </div>
        <div>
          <img style="width: 311px; height: 42px" src="../assets/white.png" />
          <div style="text-align: center;">
            <img style="width: 82px; height: 82px;margin: 10px auto;" src="../assets/SIPE.jpg" />
            <p style="font-size: 10px;">知识产权交易中心公众号</p>
          </div>


        </div>
      </div>

      <div class="sixt"></div>
      <div class="copyright flex-center">
        上海知识产权交易中心 © 版权所有
        <a href="https://beian.miit.gov.cn/" target="_blank">
          沪ICP备17055234号-1
        </a>

        <a href="https://xyt.xcc.cn/getpcInfo?sn=1589885630576308224&language=CN&certType=8&url=www.shsipe.com"
          target="_blank" style="position: relative;display: inline-block;height: 38px;">
          <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div><embed
            src="https://program.xinchacha.com/web/1589885630576308224=www.shsipe.com.svg" width="103" height="38"
            type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    downloadUrl() {
      let url = window.location.href;
      return `${url.split("#")[0]}static/上海知识产权交易平台新手教程.pdf`;
    },
  },
};
</script>

<style lang="scss">
.tail {
  width: 100%;
  background-color: #1d2129;
  color: #ffffff;

  a {
    color: #ffffff;
  }

  .copyright {
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    color: #4e5969;
    line-height: 22px;

    a {
      color: #4e5969;
      margin-left: 7px;
    }
  }

  .sixt {
    border-bottom: 1px solid #272e3b;
    margin: 32px 0;
  }

  .tai {
    width: 79.17%;
    // padding: 48px 150px 32px 150px;
    padding-top: 48px;
    padding-bottom: 32px;
    margin: 0 auto;
    // cursor: pointer;
  }

  .platform {
    display: flex;
    justify-content: space-between;
    font-size: 14px !important;
    color: #86909c;
    margin-top: 16px;
    margin-bottom: 32px;
  }

  .contact {
    display: flex;
    font-size: 16px;
    justify-content: space-between;

    .couplet {
      width: 14.3%;
      margin-right: 32px;
    }

    .feedback {
      width: 14.3%;
      margin-right: 44px;
    }

    .Telephone {
      width: 26.5%;
      margin-right: 124px;
    }
  }

  .sixteen {
    padding-bottom: 16px;
  }
}
</style>
